import { Box, Chip, useTheme } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import React from 'react';
import { INVOICE_STATUS } from '../../../constant/invoice';

const InvoiceStatus = ({ status }) => {
  const t = useTranslate();
  const theme = useTheme();
  return (
    <Box
      component={Chip}
      sx={{
        "&[class*='Chip']": {
          padding: '3px 12px',
          backgroundColor: {
            [INVOICE_STATUS.COMPLETED]: theme.palette.success.main,
            [INVOICE_STATUS.VALIDATED]: theme.palette.primary.light,
            [INVOICE_STATUS.OPEN]: theme.palette.warning.main,
            [INVOICE_STATUS.CANCELED]: theme.palette.grey[800],
          }[status],
          color: 'white',
          '& span': {
            padding: '0 !important', // To override default styles
          },
        },
      }}
      label={t(`common.invoiceStatus.${status}`)}
    />
  );
};

export default InvoiceStatus;
